/* Hondeland — theme.js */
(function () {
  'use strict';
  document.documentElement.classList.add('js');

  /* ---------- helpers ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var fmt = format || window.HondelandMoneyFormat || '€{{amount_with_comma_separator}}';
    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? '.' : thousands;
      decimal = decimal == null ? ',' : decimal;
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var c = parts[1] ? decimal + parts[1] : '';
      return dollars + c;
    }
    var value = '';
    var match = fmt.match(placeholder);
    switch (match ? match[1] : 'amount') {
      case 'amount': value = withDelimiters(cents, 2, ',', '.'); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      default: value = withDelimiters(cents, 2, '.', ',');
    }
    return fmt.replace(placeholder, value);
  }

  /* ---------- announcement rotator ---------- */
  document.querySelectorAll('[data-announcement]').forEach(function (bar) {
    var items = bar.querySelectorAll('.announcement__item');
    if (items.length < 2) return;
    var i = 0;
    var speed = parseInt(bar.dataset.speed || '5', 10) * 1000;
    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, speed);
  });

  /* ---------- header scroll state ---------- */
  var headerWrap = document.querySelector('.header-wrap');
  if (headerWrap) {
    var onScroll = function () { headerWrap.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- drawer ---------- */
  function openDrawer(drawer) {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var focusable = drawer.querySelector('button, a');
    if (focusable) focusable.focus();
  }
  function closeDrawer(drawer) {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      var d = document.getElementById(opener.getAttribute('data-drawer-open'));
      if (d) { e.preventDefault(); openDrawer(d); opener.setAttribute('aria-expanded', 'true'); }
      return;
    }
    var closer = e.target.closest('[data-drawer-close]');
    if (closer) {
      var drawer = closer.closest('.drawer');
      if (drawer) { closeDrawer(drawer); document.querySelectorAll('[data-drawer-open="' + drawer.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); }); }
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') document.querySelectorAll('.drawer.is-open').forEach(closeDrawer);
  });

  /* ---------- quantity buttons ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    var wrap = btn.closest('.qty');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var step = parseInt(btn.getAttribute('data-qty-change'), 10);
    var min = parseInt(input.min || '0', 10);
    var next = Math.max(min, (parseInt(input.value, 10) || 0) + step);
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- cart: auto-submit quantity changes ---------- */
  document.querySelectorAll('[data-cart-form]').forEach(function (form) {
    var timer;
    form.addEventListener('change', function (e) {
      if (!e.target.matches('[data-cart-qty]')) return;
      clearTimeout(timer);
      timer = setTimeout(function () {
        var update = form.querySelector('[name="update"]');
        if (form.requestSubmit && update) form.requestSubmit(update); else form.submit();
      }, 450);
    });
  });

  /* ---------- gallery ---------- */
  function initGallery(gallery) {
    var track = gallery.querySelector('.gallery__track');
    if (!track) return null;
    var slides = Array.prototype.slice.call(track.children);
    var thumbs = gallery.querySelectorAll('.gallery__thumb');
    var dots = gallery.querySelectorAll('.gallery__dot');
    function setCurrent(index) {
      thumbs.forEach(function (t, i) { t.setAttribute('aria-current', i === index ? 'true' : 'false'); });
      dots.forEach(function (d, i) { d.setAttribute('aria-current', i === index ? 'true' : 'false'); });
    }
    function goTo(index, smooth) {
      index = Math.max(0, Math.min(slides.length - 1, index));
      track.scrollTo({ left: slides[index].offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
      setCurrent(index);
    }
    function currentIndex() { return Math.round(track.scrollLeft / track.clientWidth); }
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () { setCurrent(currentIndex()); });
    }, { passive: true });
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goTo(i); }); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { goTo(i); }); });
    var prev = gallery.querySelector('.gallery__nav--prev');
    var next = gallery.querySelector('.gallery__nav--next');
    if (prev) prev.addEventListener('click', function () { goTo(currentIndex() - 1); });
    if (next) next.addEventListener('click', function () { goTo(currentIndex() + 1); });
    var api = {
      goToMedia: function (mediaId, smooth) {
        for (var i = 0; i < slides.length; i++) {
          if (slides[i].getAttribute('data-media-id') === String(mediaId)) { goTo(i, smooth); return; }
        }
      }
    };
    var initial = gallery.getAttribute('data-initial-media');
    if (initial) api.goToMedia(initial, false);
    return api;
  }

  /* ---------- product (variants, gallery, sticky bar) ---------- */
  function initProduct(root) {
    var jsonEl = root.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var gallery = root.querySelector('[data-gallery]');
    var galleryApi = gallery ? initGallery(gallery) : null;
    var strings = {
      add: root.getAttribute('data-str-add'),
      soldout: root.getAttribute('data-str-soldout'),
      unavailable: root.getAttribute('data-str-unavailable')
    };
    var moneyFormat = root.getAttribute('data-money-format');
    var groups = root.querySelectorAll('[data-option-group]');

    function selectedOptions() {
      return Array.prototype.map.call(groups, function (g) {
        var c = g.querySelector('input:checked');
        return c ? c.value : null;
      });
    }

    function markAvailability(sel) {
      groups.forEach(function (g, gi) {
        g.querySelectorAll('input').forEach(function (input) {
          var test = sel.slice(); test[gi] = input.value;
          var ok = product.variants.some(function (v) {
            return v.available && v.options.every(function (o, oi) { return oi === gi ? o === input.value : (test[oi] == null || o === test[oi]); });
          });
          input.classList.toggle('is-unavailable', !ok);
        });
      });
    }

    function update() {
      var sel = selectedOptions();
      groups.forEach(function (g, i) { var l = g.querySelector('[data-selected-value]'); if (l) l.textContent = sel[i] || ''; });
      markAvailability(sel);
      var variant = product.variants.find(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); });

      root.querySelectorAll('input[name="id"]').forEach(function (input) { if (variant) input.value = variant.id; });
      root.querySelectorAll('[data-add-button]').forEach(function (btn) {
        var label = btn.querySelector('[data-add-label]') || btn;
        if (!variant) { btn.disabled = true; label.textContent = strings.unavailable; }
        else if (!variant.available) { btn.disabled = true; label.textContent = strings.soldout; }
        else { btn.disabled = false; label.textContent = strings.add; }
      });
      root.querySelectorAll('.shopify-payment-button').forEach(function (b) { b.hidden = !(variant && variant.available); });

      if (!variant) return;
      root.querySelectorAll('[data-price]').forEach(function (p) {
        var cur = p.querySelector('[data-price-current]');
        var cmp = p.querySelector('[data-price-compare]');
        var badge = p.querySelector('[data-price-badge]');
        var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        if (cur) cur.textContent = formatMoney(variant.price, moneyFormat);
        if (cmp) { cmp.hidden = !onSale; cmp.textContent = onSale ? formatMoney(variant.compare_at_price, moneyFormat) : ''; }
        if (badge) { badge.hidden = !onSale; badge.textContent = onSale ? '-' + Math.floor((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) + '%' : ''; }
        p.classList.toggle('price--sale', !!onSale);
      });
      if (variant.featured_media && galleryApi) galleryApi.goToMedia(variant.featured_media.id);
      if (root.hasAttribute('data-update-url') && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    root.addEventListener('change', function (e) { if (e.target.closest('[data-option-group]')) update(); });
    if (groups.length) markAvailability(selectedOptions());

    /* sticky add to cart */
    var sticky = root.querySelector('[data-sticky-atc]');
    var anchor = root.querySelector('[data-sticky-anchor]');
    if (sticky && anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var past = !en.isIntersecting && en.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', past);
        });
      }).observe(anchor);
    }
  }

  document.querySelectorAll('[data-product]').forEach(function (el) { try { initProduct(el); } catch (err) { console.error('initProduct', err); } });
  document.querySelectorAll('[data-gallery]').forEach(function (g) { if (!g.closest('[data-product]')) { try { initGallery(g); } catch (err) { console.error('initGallery', err); } } });

  /* ---------- reveal on scroll ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-in'); });
  }

  /* Theme editor: re-run on section load */
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-product]').forEach(initProduct);
    e.target.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-in'); });
  });
})();

/* Kleurbolletjes op productkaarten: hover (desktop) wisselt de kaartfoto naar die kleur. */
(function () {
  function show(sw) {
    var card = sw.closest('.card'); if (!card) return;
    var img = card.querySelector('.card__media img:not(.card__hover)');
    var src = sw.getAttribute('data-swatch-img');
    if (!img || !src) return;
    if (!img.getAttribute('data-orig-src')) { img.setAttribute('data-orig-src', img.currentSrc || img.src); img.setAttribute('data-orig-srcset', img.getAttribute('srcset') || ''); }
    img.removeAttribute('srcset'); img.src = src;
    card.classList.add('is-swatching');
    card.querySelectorAll('.card__swatch').forEach(function (s) { s.classList.toggle('is-active', s === sw); });
  }
  document.addEventListener('mouseover', function (e) {
    var sw = e.target.closest && e.target.closest('.card__swatch[data-swatch-img]');
    if (sw) show(sw);
  });
})();
